import React from 'react';
import { FaCheck } from 'react-icons/fa';

export default function Pricing() {
  return (
    <section className="bg-surface py-20 sm:py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-eyebrow uppercase text-ink-3">
            Pricing
          </p>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
            Simple monthly pricing, no long-term lock-in.
          </h2>
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-3xl border border-border bg-surface-2 p-8 shadow-sm">
          <div className="flex items-end justify-center gap-2 text-ink">
            <span className="text-5xl font-semibold font-mono">$30</span>
            <span className="pb-2 text-sm text-ink-3">/month/jobsite</span>
          </div>

          <ul className="mt-8 space-y-4 text-sm text-ink-2">
            <li className="flex items-start gap-3">
              <FaCheck className="mt-1 text-active" />
              Unlimited workers
            </li>
            <li className="flex items-start gap-3">
              <FaCheck className="mt-1 text-active" />
              Real-time clock in and out with GPS and geofencing
            </li>
            <li className="flex items-start gap-3">
              <FaCheck className="mt-1 text-active" />
              Facial recognition with liveness detection
            </li>
            <li className="flex items-start gap-3">
              <FaCheck className="mt-1 text-active" />
              Cancel anytime, no contracts
            </li>
          </ul>

          <a
            href="/register"
            className="mt-8 block rounded-xl bg-ink px-5 py-3 text-center text-sm font-semibold text-white transition hover:bg-ink-2"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}
